<template>
    <svg class="icon-pause" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 11"><g><rect width="3" height="11"/><rect x="6" width="3" height="11"/></g></svg>
</template>
